/* The seven-step trail. Hairline connectors, one dot per step, the words under the dot. Tokens only
   (ADR-0007). The connector is drawn by the next step's `::before`, so it is the *arriving* step
   that colours the line leading into it: a step is reached or it is not. */

.trail {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  margin: 0;
  padding: 0;
  list-style: none;
}

.step {
  position: relative;
  display: grid;
  gap: 6px;
  justify-items: center;
  min-width: 0;
  padding-top: 2px;
  text-align: center;
}

.step + .step::before {
  position: absolute;
  top: 13px;
  right: 50%;
  width: 100%;
  height: 2px;
  background: var(--line);
  content: "";
  transition: background-color var(--dur-3) var(--ease-out);
}

.step.done + .step::before,
.step.done + .step.current::before {
  background: var(--accent);
}

.dot {
  position: relative;
  z-index: 1;
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border: 1.5px solid var(--line-2);
  border-radius: var(--radius-pill);
  background: var(--panel);
  color: var(--muted);
  transition:
    background-color var(--dur-3) var(--ease-out),
    border-color var(--dur-3) var(--ease-out),
    transform var(--dur-3) var(--ease-out);
}

.done .dot {
  border-color: var(--accent);
  background: var(--accent);
  color: var(--on-fill);
}

.current .dot {
  border-color: var(--accent);
  color: var(--accent);
}

.waiting .dot {
  border-color: var(--warn);
  background: var(--warn-w);
  color: var(--warn);
}

.failed .dot {
  border-color: var(--crit);
  background: var(--crit-w);
  color: var(--crit);
}

.words {
  display: grid;
  gap: 1px;
  justify-items: center;
  min-width: 0;
}

.label {
  font-size: var(--t-min);
  font-weight: 650;
  line-height: 1.25;
  color: var(--ink-2);
}

.todo .label {
  font-weight: 500;
  color: var(--muted);
}

.detail {
  font-size: var(--t-min);
  line-height: 1.25;
  color: var(--muted);
  overflow-wrap: anywhere;
}

.waiting .detail {
  color: var(--warn);
}

.failed .detail {
  color: var(--crit);
}

.spin {
  animation: trail-spin 900ms linear infinite;
}

@keyframes trail-spin {
  to {
    transform: rotate(360deg);
  }
}

/* The compact variant (table rows): seven small dots, no words. */
.compact {
  grid-template-columns: repeat(7, 14px);
  gap: 4px;
}

.compact .step {
  display: block;
  padding-top: 0;
}

.compact .step + .step::before {
  display: none;
}

.compact .dot {
  width: 14px;
  height: 14px;
  border-width: 1px;
}

.compact .dot svg {
  width: 9px;
  height: 9px;
}

/* Narrow: two rows rather than seven cramped columns; the connectors go (they would cross rows). */
@media (max-width: 700px) {
  .trail:not(.compact) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    row-gap: 12px;
  }

  .trail:not(.compact) .step + .step::before {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .spin {
    animation: none;
  }

  .dot,
  .step + .step::before {
    transition: none;
  }
}
